import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  DataStateChangeEvent,
  GridDataResult,
} from '@progress/kendo-angular-grid';
import { ReportService } from '../../../services';
import {
  ColumnOptions,
  GridState,
  LoaderService,
  MessageService,
  ValidationResultService,
} from '@shared';
import { GridRowDeliveryException } from '../../../models/delivery-exception.model';
import { SortDescriptor } from '@progress/kendo-data-query';

@Component({
  selector: 'app-delivery-exceptions',
  templateUrl: './delivery-exceptions.component.html',
  styleUrl: './delivery-exceptions.component.scss',
})
export class DeliveryExceptionsComponent {
  reportType!: string;

  deliveryExceptions: GridDataResult = { data: [], total: 0 };

  columns: ColumnOptions[] = [];

  state!: GridState;

  pageSize: number = 10;

  fontSize: number = 0.875;

  initialSort: SortDescriptor[] = [
    { field: 'deliveryUpchargePercentage', dir: 'desc' },
    { field: 'tierName', dir: 'asc' },
    { field: 'restaurantName', dir: 'asc' },
    { field: 'sortOrder', dir: 'asc' },
    { field: 'itemName', dir: 'asc' },
  ];

  constructor(
    private route: ActivatedRoute,
    private reportService: ReportService,
    private messageService: MessageService,
    private loaderService: LoaderService,
    private validationErrorService: ValidationResultService,
  ) {
    this.columns = new GridRowDeliveryException().getColumns();
  }

  ngOnInit() {
    this.subscribeToReportChange();
  }

  setDefaultState(): void {
    this.state = new GridState(this.pageSize, this.initialSort);

    this.fetchReportData();
  }

  subscribeToReportChange() {
    this.route.params.subscribe((params) => {
      this.reportType = params['type'];

      this.setDefaultState();
    });
  }

  fetchReportData() {
    this.loaderService.show();
    this.reportService
      .getReportData(`delivery/${this.reportType}`, this.state)
      .subscribe({
        next: (data) => {
          this.deliveryExceptions = data;

          this.deliveryExceptions.data = this.deliveryExceptions.data.map(
            (item) =>
              new GridRowDeliveryException(
                item.parItemId,
                item.plu,
                item.itemName,
                item.itemPrice,
                item.deliveryPrice,
                item.deliveryUpchargePercentage,
                item.restaurantName,
                item.tierName,
                item.itemType,
                item.isActive,
              ),
          );
          this.loaderService.hide();
        },
        error: (error) => {
          this.messageService.error(`Failed to load delivery exceptions`);
          var validationError = error?.error;
          if (validationError) {
            this.validationErrorService.show(validationError);
          }
          this.loaderService.hide();
        },
      });
  }

  onDataStateChanged(event: DataStateChangeEvent) {
    this.state = event as GridState;

    this.fetchReportData();
  }

  exportExceptions() {
    this.loaderService.show();
    this.reportService
      .exportExceptions(`delivery/${this.reportType}`)
      .subscribe({
        next: (data: Blob) => {
          const blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `${this.reportType}_Exceptions_${new Date().toDateString()}.xlsx`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
          this.loaderService.hide();
        },
        error: (error) => {
          this.loaderService.hide();
          this.messageService.error(`Failed to export delivery exceptions`);
          var validationError = error?.error;
          if (validationError) {
            this.validationErrorService.show(validationError);
          }
        },
      });
  }
}
